import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaPhone, FaSignInAlt, FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/logoelite.jpeg";
import PdfModalViewer from "./PdfModalViewer";
import thirdClass from "../assets/ThirdClass.jpg";
import fourthClass from "../assets/FourthClass.jpg";
import fifthClass from "../assets/Fifth.jpg";
import sixth from "../assets/Sixth.jpg";
import seventh from "../assets/Seventh.jpg";
import eigth from "../assets/Science.jpg";
import ninth from "../assets/Ninth.jpg";
import tenth from "../assets/Tenth.jpg";

const SampleCopy = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // PDF modal state
  const [showPdf, setShowPdf] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState("");

  const go = (p) => {
    setMenuOpen(false);
    navigate(p);
  };

  // Map each class to a PDF file inside public/pdfs/
  const pdfFiles = {
    3: "3rd.pdf",
    4: "4th.pdf",
    5: "5th.pdf",
    6: "6th.pdf",
    7: "7th.pdf",
    8: "8th.pdf",
    9: "9th.pdf",
    10: "10th.pdf"
  };

  const classes = [
    { id: 3, title: "3rd Class Sample Copy", img: thirdClass },
    { id: 4, title: "4th Class Sample Copy", img: fourthClass },
    { id: 5, title: "5th Class Sample Copy", img: fifthClass },
    { id: 6, title: "6th Class Sample Copy", img: sixth },
    { id: 7, title: "7th Class Sample Copy", img: seventh },
    { id: 8, title: "8th Class Sample Copy", img: eigth },
    { id: 9, title: "9th Class Sample Copy", img: ninth },
    { id: 10, title: "10th Class Sample Copy", img: tenth }
  ];

  const ordinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  // Open correct PDF dynamically
  const handleOpenPdf = (id) => {
    const file = pdfFiles[id];
    if (!file) return;

    // Path to public/pdfs/ file
    setSelectedPdf(`/pdfs/${encodeURIComponent(file)}`);
    setShowPdf(true);
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* HEADER */}
      <header className="header" style={{ position: "sticky", top: 0, zIndex: 90 }}>
        <div className="logo-container">
          <img
            src={logo}
            alt="Elite Academy Logo"
            className="logo"
            style={{
              height: 70,
              width: "auto",
              marginRight: 8,
              transformOrigin: "left center"
            }}
          />
          <span className="logo-text">Elite Academy</span>
        </div>

        <button className="menu-icon" aria-label="Toggle menu" onClick={() => setMenuOpen((s) => !s)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button className="nav-btn-link" onClick={() => go("/")}>HOME</button>
          <button className="nav-btn-link" onClick={() => go("/about")}>ABOUT US</button>
          <button className="nav-btn-link" onClick={() => go("/features")}>FEATURES</button>
          <button className="nav-btn-link" onClick={() => go("/contact")}>CONTACT US</button>
        </nav>

        <div className="header-right">

          <a className="phone-btn" href="tel:+917330643345">
            <FaPhone /> +91 7330643345
          </a>

          <button className="login-btn" onClick={() => go("/login")}>
            <FaSignInAlt /> Login
          </button>
        </div>
      </header>

      {/* HERO SECTION */}
      <section
        style={{
          background: "linear-gradient(135deg,#512da8,#1e88e5)",
          color: "#fff",
          padding: "56px 20px",
          textAlign: "center"
        }}
      >
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <h1 style={{ fontSize: 36, marginBottom: 8 }}>
            Elite Academy Sample Copies for IIT JEE and NEET Foundation
          </h1>
          <p style={{ maxWidth: 900, margin: "0 auto", opacity: 0.95 }}>
            Use the links below to view class-specific sample copies.
          </p>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <main style={{ flex: 1, padding: 32, background: "#f7fafc" }}>
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
            gap: 20
          }}
        >
          {classes.map((c) => (
            <article
              key={c.id}
              style={{
                background: "#fff",
                borderRadius: 12,
                overflow: "hidden",
                boxShadow: "0 8px 24px rgba(16,24,40,0.06)"
              }}
            >
              <div style={{ height: 160, overflow: "hidden" }}>
                <img
                  src={c.img}
                  alt={c.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>

              <div style={{ padding: 16 }}>
                <h3 style={{ margin: "0 0 8px 0" }}>{c.title}</h3>
                <p style={{ margin: 0, color: "#475569" }}>
                  View the sample copy for class {c.id}. Click the button below to open the sample.
                </p>

                <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
                  <button
                    onClick={() => handleOpenPdf(c.id)}
                    style={{
                      padding: "8px 12px",
                      borderRadius: 8,
                      border: "none",
                      background: "#512da8",
                      color: "#fff",
                      cursor: "pointer",
                      fontWeight: 600
                    }}
                  >
                    View {ordinal(c.id)} Class Sample Copy
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </main>

      {/* FOOTER */}
      <footer
        className="footer"
        style={{
          padding: 24,
          textAlign: "center",
          background: "#fff",
          borderTop: "1px solid #eef2f7"
        }}
      >
        <p style={{ margin: 0, color: "#6b7280" }}>
          &copy; {new Date().getFullYear()} Elite Academy. All Rights Reserved.
        </p>
      </footer>

      {/* PDF MODAL VIEWER */}
      {showPdf && (
        <PdfModalViewer
          fileUrl={selectedPdf}
          onClose={() => setShowPdf(false)}
        />
      )}
    </div>
  );
};

export default SampleCopy;
